/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertRfiMessage } from './InternalApiAlertRfiMessage';
import {
    InternalApiAlertRfiMessageFromJSON,
    InternalApiAlertRfiMessageFromJSONTyped,
    InternalApiAlertRfiMessageToJSON,
    InternalApiAlertRfiMessageToJSONTyped,
} from './InternalApiAlertRfiMessage';

/**
 * 
 * @export
 * @interface InternalApiAlertRfiMessagesPage
 */
export interface InternalApiAlertRfiMessagesPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertRfiMessagesPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertRfiMessagesPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertRfiMessagesPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiAlertRfiMessage>}
     * @memberof InternalApiAlertRfiMessagesPage
     */
    content: Array<InternalApiAlertRfiMessage>;
}

/**
 * Check if a given object implements the InternalApiAlertRfiMessagesPage interface.
 */
export function instanceOfInternalApiAlertRfiMessagesPage(value: object): value is InternalApiAlertRfiMessagesPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiAlertRfiMessagesPageFromJSON(json: any): InternalApiAlertRfiMessagesPage {
    return InternalApiAlertRfiMessagesPageFromJSONTyped(json, false);
}

export function InternalApiAlertRfiMessagesPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfiMessagesPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiAlertRfiMessageFromJSON)),
    };
}

export function InternalApiAlertRfiMessagesPageToJSON(json: any): InternalApiAlertRfiMessagesPage {
    return InternalApiAlertRfiMessagesPageToJSONTyped(json, false);
}

export function InternalApiAlertRfiMessagesPageToJSONTyped(value?: InternalApiAlertRfiMessagesPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiAlertRfiMessageToJSON)),
    };
}

